module.exports = __webpack_public_path__ + "img/car-wrench.725ba84b.svg";